import React from "react"
import { Link } from "gatsby"
import Layout from "@components/layout"
import SEO from "@components/seo"
import WebriqForm from "@webriq/gatsby-webriq-form"
import { LazyLoadComponent } from "react-lazy-load-image-component"
import { Container, Row, Col } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"

import Video from "@components/sections/foundation-video"
import Shop from "@components/sections/shop"
import PageHeading from "../components/pageHeading"
import HeadingBG from "../images/RallyPgHeaderImg.jpg"

const Rally = () => (
  <Layout>
    <SEO title="Rally" />
    <div className="rally">
      <PageHeading Heading="RALLY THE REVOLUTIONARIES" BgImg={HeadingBG} />

      <section className="rally-section section-padding">
        <Container>
          <Row>
            <Col lg="10" className="mx-auto">
              <div className="rally-content text-left">
                <iframe
                  className="mb-4 iframe-video"
                  src="https://player.vimeo.com/video/669697503?h=1577fe2ff7?&autoplay=1&title=0&byline=0" 
                  type="video/mp4"
                  width="100%" height="560" frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                />
                <h5 className="d-flex justify-content-center font-weight-bold mb-5 align-items-center">
                  From the moment we are born we are taught to resist
                  everything. We suffocate our lives and our imagination with
                  fear and doubt. Yet we were born on a world that knows no
                  limits and thrives effortlessly as it flows in harmony with
                  universal forces
                </h5>

                <p>
                  We normalized a world where every label or measurement
                  possible from politics to science to theology is used to brand
                  us, isolate us, and further divide us from ourselves, each
                  other, and our environment. As our sense of Self developed, we
                  started to feel separate from Everything. The awareness of our
                  humanity began to fade, my friends. Many more than ever
                  questioned the meaning of our lives in this losing game of
                  resistance. We were losing everything, and it started with
                  hope. We lost relationships, peace of mind, happiness and even
                  our faith in whether we really could have a truly purposeful
                  life.
                </p>
                <p>
                  But now, we can see what we’ve denied ourselves. We have
                  awakened to the truth! We’ve become slaves to a detached way
                  of thinking and a resistant way of life that goes completely
                  contrary to the flow of universal forces. A way that has held
                  us apart for far too long and created a mindset and
                  perspective that has really become a prison of our own making.
                  And, especially during the pandemic, we’ve experienced that no
                  matter the success, wealth, or awards in life, without our
                  Connection, life feels empty and unfulfilled.
                </p>
                <p>
                  Today, however, all this changes! Let it be known from this
                  time and place to friends and foe alike, that we accept a new
                  rite-of-passage––one that belongs to a new vanguard of
                  humanity unwilling to permit the undoing of our human
                  connection, confidence, and dignities. And let everyone know,
                  whether they wish us well or ill, that we shall rise and pay
                  any price to live our lives in to the fullest and to Feel
                  Alive!
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="rally-contact section-padding">
        <Container>
          <Row>
            <Col lg="6" className="mb-4">
              {" "}
              <LazyLoadComponent>
                <WebriqForm
                  webriqform="true"
                  name="Join the Revolution"
                  id="revolution"
                  className="revolution-form"
                  data-form-id="7b680f28-be72-4e3e-a26b-73e040ac8f22"
                  data-thankyou-url="/thank-you"
                >
                  <div className="form-container">
                    {" "}
                    <h2 className="mb-3 font-weight-bold">
                      Sign up for first access to new products and events!
                    </h2>
                    <div className="form-group my-4">
                      <label className="mt-0">
                        First Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="firstname"
                        className="form-control"
                        name="First Name"
                        placeholder=""
                        required
                      />

                      <label className="mt-4">
                        Last Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="lastname"
                        className="form-control"
                        name="Last Name"
                        placeholder=""
                        required
                      />
                      <label className="mt-4">
                        Email Address <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="Email address"
                        placeholder=""
                        required
                      />

                      <label className="mt-4">
                        Phone Number <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="phone"
                        className="form-control"
                        name="Phone Number"
                        placeholder=""
                        required
                      />

                      <label for="birthday" className="mt-4">
                        Birthday
                      </label>
                      <br />
                      <input type="date" id="birthday" name="birthday" />
                      <br />
                      <label className="mt-4">
                        Zip/Postal Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="zipcode"
                        className="form-control"
                        name="Zip/Postal Code"
                        placeholder=""
                        required
                      />
                      <div className="d-flex mt-4">
                        {" "}
                        <input
                          type="checkbox"
                          id="volunteer"
                          name="volunteer"
                          value="volunteer"
                          className="mr-3 mt-1"
                        />
                        <label for="volunteer">
                          {" "}
                          Check this box for volunteer opportunities if you're
                          really ready to rally!!
                        </label>
                      </div>

                      <br></br>
                      <div className="webriq-recaptcha" />
                      <button className="footer-button mt-4" type="submit">
                        Submit
                      </button>
                    </div>
                  </div>
                </WebriqForm>
              </LazyLoadComponent>
            </Col>
            <Col lg="1" />
            <Col lg="5">
              {" "}
              <h2 className="mb-3 font-weight-bold text-white">
                You didn't come here by accident!
              </h2>
              <h2 className="mb-3 font-weight-bold text-white">
                You're an explorer, like the rest of us, and we're glad you
                found FLUO.
              </h2>
              <h2 className="mb-3 font-weight-bold text-white">
                We believe there are two ways to live:
              </h2>
              <ul className="text-white">
                <li>
                  <p>
                    {" "}
                    Resist anyone or anything that threatens to nudge you from
                    your comfort zone.
                  </p>
                </li>
                <li>
                  <p>
                    Devote your life to freeing yourself from the self-imposed
                    limits you learned.
                  </p>
                </li>
              </ul>
              <p className="mb-3 text-white">
                We choose the latter. We choose to go with the flow. The FLUO
                Family uses this incredible experience we call LIFE to free
                ourselves... and we're willing to pay any price for the freedom
                of our soul. It's a celebration of life transformed!! If you
                want to be a part of a family devoted to exploring the true
                nature and Source of our being, you've found us. It's time to
                let that inner energy flow! It's time to Feel Alive!
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section
        className="rally-flow-section"
        style={{ padding: "150px 0 60px" }}
      >
        <Container>
          <Row>
            <Col lg="9" className="mx-auto">
              <div className="steward-flow-content text-center text-white">
                <h2 className="d-flex justify-content-center section-title mb-5 align-items-center">
                  <span className="ml-2">
                    <StaticImage
                      className="img-fluid ml-2"
                      src="../../images/flow-logo.png"
                      alt="Logo"
                    />
                  </span>
                </h2>
                <h3 className="mb-5 youthtouch">
                  The greatest revolution we can imagine is the elevation of our
                  consciousness.
                </h3>
                <h5 className="youthtouch">#FeelAlive</h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <div>
        <Shop />
      </div>
      <section className="prefooter-section section-padding">
        <Container fluid>
          <div class="row d-flex justify-content-center">
            <div class="col-lg-3 col-md-6 mb-4">
              <div className="prefooter-list text-center text-white">
                <div className="product-item">
                  <Link to="/stories/" className="">
                    <StaticImage
                      className="img-fluid mb-3"
                      width={120}
                      height={100}
                      src="../../images/our-story.png"
                      alt="Our Story"
                    />
                    <h3 className="font-weight-bold mb-3">Our Story</h3>
                  </Link>
                  <p className="mb-4">
                    We want to bend history in the right direction.
                  </p>
                  <Link to="/stories/" className="cta-2 text-uppercase ">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
              <div className="prefooter-list text-center text-white">
                <div className="product-item">
                  <Link to="/belief/" className="">
                    <StaticImage
                      className="img-fluid mb-3"
                      width={100}
                      height={100}
                      src="../../images/our-beliefs.png"
                      alt="Our Beliefs"
                    />
                    <h3 className="font-weight-bold mb-3">Our Beliefs</h3>
                  </Link>
                  <p className="mb-4">
                    Discover the Art of Living. Know freedom. Feel Alive
                    <sup>®</sup>.
                  </p>
                  <Link to="/belief/" className="cta-2 text-uppercase ">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
              <div className="prefooter-list text-center text-white">
                <div className="product-item">
                  <Link to="/why-fluo/" className="">
                    <StaticImage
                      className="img-fluid mb-3"
                      width={100}
                      height={100}
                      src="../../images/our-youth.png"
                      alt="Our Youth"
                    />
                    <h3 className="font-weight-bold mb-3">Our Youth</h3>
                  </Link>
                  <p className="mb-4">
                    Discover the FLUO Foundation, a youth mental health
                    nonprofit.
                  </p>
                  <Link to="/why-fluo/" className="cta-2 text-uppercase ">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
              <div className="prefooter-list text-center text-white">
                <div className="product-item">
                  <Link to="/stewardship/" className="">
                    <StaticImage
                      className="img-fluid mb-3"
                      width={100}
                      height={100}
                      src="../../images/our-ways.png"
                      alt="Our Ways"
                    />
                    <h3 className="font-weight-bold mb-3">Our Ways</h3>
                  </Link>
                  <p className="mb-4">Consciousness & Stewardship</p>
                  <Link to="/stewardship/" className="cta-2 text-uppercase ">
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  </Layout>
)

export default Rally
